/** @format */

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Table from "../../extra/Table";
import Iconb from "../../extra/Iconb";
import { connect, useDispatch, useSelector } from "react-redux";
import { getUser, userIsBlock } from "../../store/user/user.action";
import { forceLogoutUser } from "../../store/admin/admin.action";
import ToggleSwitch from "../../extra/ToggleSwitch";
import dayjs from "dayjs";
import Pagination from "../../extra/Pagination";
import Searching from "../../extra/Searching";
import Skeleton from "react-loading-skeleton";
import { colors } from "../../../util/SkeletonColor";
import "react-loading-skeleton/dist/skeleton.css";
import { getImageUrl } from "../../../util/getImageUrl";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";

const User = (props) => {
	const [size, setSize] = useState(10);
	const [page, setPage] = useState(1);
	const [data, setData] = useState([]);
	const [loading, setLoading] = useState(true);
	const [search, setSearch] = useState("");
	const [currentPage, setCurrentPage] = useState(1);
	const [rowsPerPage, setRowsPerPage] = useState(10);
	const { user, totalUser } = useSelector((state) => state.user);
	const dispatch = useDispatch();

	const navigate = useNavigate();

	useEffect(() => {
		dispatch(getUser(currentPage, size));
	}, [dispatch, currentPage, size]);

	useEffect(() => {
		const timer = setTimeout(() => {
			setLoading(false);
		}, 1500); // Adjust the delay time as needed

		return () => clearTimeout(timer);
	}, []);

	useEffect(() => {
		setData(user);
	}, [user]);

	// pagination
	const handleChangePage = (event, newPage) => {
		setCurrentPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event), 10);
		setSize(parseInt(event), 10);
		setCurrentPage(1);
	};

	const handleOpen = (id) => {
		navigate("/admin/UserProfile", {
			state: id,
		});
	};

	const handleClick = (userDetails) => {
		props.userIsBlock(userDetails, userDetails?.isBlock === true ? false : true);
	};

	// Force-logout: bumps the user's tokenVersion server-side so every active
	// JWT for this account becomes stale. We confirm because it can disrupt a
	// user mid-session.
	const handleForceLogout = (userDetails) => {
		if (!userDetails?._id) return;
		const confirmed = window.confirm(`Force logout ${userDetails.firstName || "this user"} from every device?`);
		if (!confirmed) return;
		dispatch(forceLogoutUser(userDetails._id));
	};

	// searching
	const handleFilterData = (filteredData) => {
		if (typeof filteredData === "string") {
			setSearch(filteredData);
		} else {
			setData(filteredData);
		}
	};

	const mapData = [
		{
			Header: "No",
			width: "20px",
			Cell: ({ index }) => <span className=''>{(currentPage - 1) * rowsPerPage + index + 1}</span>,
		},
		{
			Header: "User",
			body: "firstName",
			Cell: ({ row }) => (
				<div className='d-flex' onClick={() => handleOpen(row._id)} style={{ cursor: "pointer" }}>
					<div className='position-relative'>
						{loading ? (
							<>
								<Skeleton height={42} width={42} style={{ borderRadius: "90px" }} className='StripeElement ' baseColor={colors?.baseColor} highlightColor={colors?.highlightColor} />
							</>
						) : (
							<>
								<img
									src={getImageUrl(row?.image) || "/dummy.png"}
									height={45}
									width={45}
									alt=''
									style={{ borderRadius: "90px" }}
									onError={(e) => {
										e.target.onerror = null;
										e.target.src = "/dummy.png";
									}}
								/>
							</>
						)}
					</div>
					<span className='fw-normal ms-3 boxCenter text-start '>
						<b className='fw-normal text-capitalize'>{row.firstName + " " + row.lastName}</b>
					</span>
				</div>
			),
			sorting: false, //you can on if sorting need
		},

		{
			Header: "Contact",
			body: "email",
			sorting: false,
			Cell: ({ row }) => (
				<div className=''>
					<span className='fw-normal'>{row.email ? row.email : "Era@gmail.com"}</span>
					<p className='mb-0 fw-normal'>{row.mobileNumber ? row.mobileNumber : "-"}</p>
				</div>
			),
		},

		{
			Header: "Unique Id",
			body: "uniqueId",
			sorting: false,

			Cell: ({ row }) => <p className='mb-0'>{row.uniqueId ? row.uniqueId : "-"}</p>,
		},
		{
			Header: "Location",
			body: "location",
			Cell: ({ row }) => <p className='mb-0 text-uppercase'>{row.location ? row.location : "-"}</p>,
		},
		{
			Header: "Total Order",
			body: "orderCount",
			Cell: ({ row }) => <span className='count-badge'>{row.orderCount ? row.orderCount : 0}</span>,
		},
		{
			Header: "Register Date",
			body: "createdAt",
			Cell: ({ row }) => <span className=''>{dayjs(row.date).format("DD MMM YYYY")}</span>,
		},
		{
			Header: "Block",
			body: "isBlock",
			Cell: ({ row }) => (
				<div className=''>
					<ToggleSwitch value={row.isBlock} onClick={() => handleClick(row)} disabled={row?.email === "declotrtest@gmail.com" && true} />
				</div>
			),
		},

		{
			Header: "Info",
			body: "",
			Cell: ({ row }) => (
				<button className='action-icon-btn' onClick={() => handleOpen(row._id)}>
					<InfoOutlinedIcon sx={{ fontSize: 18 }} />
				</button>
			),
		},

		{
			Header: "Sessions",
			body: "",
			Cell: ({ row }) => (
				<button className='action-icon-btn text-danger' title='Force logout from every device' onClick={() => handleForceLogout(row)}>
					<LogoutRoundedIcon sx={{ fontSize: 18 }} />
				</button>
			),
		},

		// add more columns as needed
	];
	return (
		<>
			<div className='mainUserTable'>
				<div className='userTable'>
					<div className='col-12 headname'>User Management </div>

					<div className='userMain'>
						<div className='tableMain mt-2'>
							<div className='userHeader primeHeader'>
								<div className='row'>
									<div className='col-2'></div>
									<div className='col-10'>
										<Searching type={`client`} data={user} setData={setData} column={data} onFilterData={handleFilterData} serverSearching={handleFilterData} button={true} setSearchValue={setSearch} searchValue={search} />
									</div>
								</div>
							</div>
							<Table data={data} mapData={mapData} serverPerPage={rowsPerPage} serverPage={page} type={"server"} />
							<Pagination component='div' count={user?.length} type={"server"} onPageChange={handleChangePage} serverPerPage={rowsPerPage} totalData={totalUser} serverPage={currentPage} setCurrentPage={setCurrentPage} onRowsPerPageChange={handleChangeRowsPerPage} />
						</div>
					</div>
					<div className='userFooter primeFooter'></div>
				</div>
			</div>
		</>
	);
};

export default connect(null, { getUser, userIsBlock })(User);
